module.exports = __webpack_public_path__ + "static/media/tablecus.5ecbb437.svg";